(ns bp-clients.tv-app.common.components.carousel
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.utils.keycodes :as keycodes]
   [bp-clients.tv-app.utils.utils :as utils]
   [bp-libs.design-system.components.carousel :refer [carousel]]
   [reagent.core :as r]))

(defn- update-carousel-scroll
  [react-ref value step-3d]
  (let [step-3d (or step-3d "17.5vw")]
    (set! (-> react-ref .-current .-style .-transform)
          (str "translate3d(calc(" @value "*" step-3d "*-1), 0, 0)"))))

(defn- focus-selected-card [ref selected-card]
  (when-let [selected-card-el (-> (.-current ref)
                                  (.querySelectorAll "*[tabindex=\"10\"]")
                                  vec
                                  (get @selected-card))]
    (.focus selected-card-el)))

(defn carousel-3d
  [config]
  (let [selected-card      (r/atom 0)
        ignore-navigation? (or (:ignore-navigation? config) (r/atom false))
        ref                (or (:react-ref config) (createRef))
        set-val            (partial update-carousel-scroll ref selected-card (:step-3d config))
        on-navigate        (:on-navigate config)
        thumb-count        (-> config :thumbs count dec (max 0))
        min-ahead-items    10
        dom-items          (r/atom min-ahead-items)
        scroll-to-card     #(do
                              (reset! dom-items (+ min-ahead-items @selected-card))
                              (reset! ignore-navigation? true)
                              (reset! selected-card %)
                              (focus-selected-card ref selected-card)
                              (set-val))]
    (fn []
      [:div {:on-focus    #(when (utils/focus-inside? (.-current ref))
                             (focus-selected-card ref selected-card)
                             (reset! ignore-navigation? false))
             :on-key-down #(let [keyCode (-> % .-keyCode)]
                             (when (or (keycodes/left? keyCode) (keycodes/right? keyCode))
                               (when on-navigate (on-navigate))
                               (utils/stop-event-propagation %)

                               (when-not @ignore-navigation?
                                 (cond
                                   (keycodes/left? keyCode)
                                   (if (zero? @selected-card)
                                     (.focus js/SpatialNavigation "menu")
                                     (scroll-to-card (max (dec @selected-card) 0)))

                                   (keycodes/right? keyCode)
                                   (when (< @selected-card thumb-count)
                                     (scroll-to-card (min (inc @selected-card) thumb-count)))

                                   :else nil))))}

       [carousel (merge config {:thumbs            (take @dom-items (:thumbs config))
                                :use-3d?           true
                                :react-ref         ref
                                :scroll-div-class  "translate-x"
                                :on-transition-end (fn [e]
                                                     (when (and (-> e .-target .-classList set (contains? "translate-x"))
                                                                (utils/focus-inside? (.-current ref)))
                                                       (reset! ignore-navigation? false)))})]])))
